import { pxToEm } from '@insticator/insticator-ui';

export default {
    paymenttermsection: {
        display: 'flex',
        flexDirection: 'column',
        padding: pxToEm(0),
        paddingBottom: pxToEm(150),
        alignSelf: 'flex-start',
        position: 'relative',
        zIndex: 10,
        '& .name-paymentterm': {
            display: 'flex',
            flexDirection: 'column',
        },
        '& .title': {
            padding: 0,
            margin: 0,
            '& p': {
                fontSize: pxToEm(14),
                paddingBottom: pxToEm(16),
            }
        },
        '& .singleselectdropdown': {
            zIndex: 9,
        }
    }
};
